import { Box, Flex, forwardRef, Grid, Text } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import { useRef, useState } from 'react'

import type { OfferVehicle } from 'BrokerTsLib/src/dtos'
import { OfferCar } from './OfferCar'

export interface GroupedOffersProps {
  parameters?: {
    label: string
    value: string
  }[]
  offerId?: string
  offers: OfferVehicle[]
}

export const animationVariants = {
  visible: { originY: 0, opacity: 1, scaleY: 1, transition: { duration: 0.3 } },
  hidden: { originY: 0, opacity: 0, scaleY: 0, transition: { duration: 0.3 } },
}

export const GroupedOffersWrapper = forwardRef<Omit<GroupedOffersProps, 'title'>, 'div'>(
  ({ children, ...rest }, ref) => {
    return (
      <Box
        sx={{ display: 'grid', gap: 4, p: { base: 2, lg: 4 }, bg: 'gray.200', borderRadius: 'md' }}
        ref={ref}
        {...rest}
      >
        {children}
      </Box>
    )
  },
)

export const AnimatedGroupedOffersWrapper = motion(GroupedOffersWrapper)

export const GroupedOffers = ({ parameters, offerId, offers }: GroupedOffersProps) => {
  const [isVisible, setIsVisible] = useState(true)
  const offerRef = useRef<HTMLDivElement>(null)
  const elementId = `grouped-offer-${offerId}`
  const handleToggle = () => {
    setIsVisible(!isVisible)

    setTimeout(() => {
      offerRef.current?.remove()
    }, 300)
  }

  return (
    <AnimatedGroupedOffersWrapper
      id={elementId}
      ref={offerRef}
      animate={isVisible ? 'visible' : 'hidden'}
      variants={animationVariants}
    >
      <Flex sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
        <Flex sx={{ gap: 4 }}>
          {parameters &&
            parameters.length > 0 &&
            parameters.map(({ label, value }, i) => {
              return (
                <Grid key={value} sx={{ gap: 0 }}>
                  <Text sx={{ fontSize: 'xs' }}>{label}</Text>
                  <Text sx={{ fontSize: 'sm', fontWeight: 'semibold' }}>{value}</Text>
                </Grid>
              )
            })}
        </Flex>

        {/* TODO: implementovat skrytí všech nabídek ve skupině  */}
        {/* <Switch isChecked={isVisible} onChange={handleToggle} /> */}
      </Flex>

      {offers &&
        offers.length > 0 &&
        offers.map((offer) => (
          <OfferCar
            key={offer.offerId}
            offer={offer}
          // key={offer.quoteId}
          // status={String(offer.status)}
          // quoteId={String(offer.quoteId)}
          // company={offer.company}
          // validUntil={offer.validUntil}
          // addGapDefend={offer.addGapDefend}
          />
        ))}
    </AnimatedGroupedOffersWrapper>
  )
}
